import { getIsElectron } from "@/hooks/useElectronEnvironment";

/** 桌面端：用户点「取消/关闭」后本会话不再弹异品牌窗，重启应用后重置 */
let desktopCrossBrandPromptSuppressed = false;

export function suppressCrossBrandPromptForDesktopSession(): void {
  if (!getIsElectron()) return;
  desktopCrossBrandPromptSuppressed = true;
}

export function isCrossBrandPromptSuppressedForDesktopSession(): boolean {
  return getIsElectron() && desktopCrossBrandPromptSuppressed;
}
